import { useLicense } from '../api';
import { PlanPicker } from './plan-picker';

/**
 * A oferta de plano fora da tela de licenca. Some assim que ha plano: quem ja
 * contratou esta ali para resolver outra coisa.
 */
export function PlanOffer() {
  const license = useLicense();

  if (license.isLoading || license.data?.plan) return null;

  return <PlanPicker atual={null} />;
}
